import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { Currency } from '@freelancer/datastore/collections';
import { Margin } from '@freelancer/ui/margin';
import { ProgressFill } from '@freelancer/ui/progress-bar';
import { FontWeight, TextSize } from '@freelancer/ui/text';
import { UserPerspective } from 'app/quotations/quotations.types';

export enum FundType {
  AVAILABLE = 'available',
  RELEASED = 'released',
}
@Component({
  selector: 'app-quotation-payment-status-progress',
  template: `
    <fl-bit class="ProgressLabel">
      <fl-text [size]="TextSize.XXSMALL">
        <!-- Available Funds Label -->
        <ng-container
          *ngIf="fundType === FundType.AVAILABLE; else releasedFunds"
          [ngSwitch]="userPerspective"
        >
          <ng-container
            *ngSwitchCase="UserPerspective.CLIENT"
            i18n="Quotation Available Funds Progress Bar Label - Client view"
          >
            Funded by you
          </ng-container>
          <ng-container
            *ngSwitchCase="UserPerspective.FREELANCER"
            i18n="
              Quotation Available Funds Progress Bar Label - Freelancer view
            "
          >
            Funded by client
          </ng-container>
        </ng-container>

        <!-- Released Funds Label -->
        <ng-template #releasedFunds [ngSwitch]="userPerspective">
          <ng-container
            *ngSwitchCase="UserPerspective.CLIENT"
            i18n="Quotation Freelancer Funds Progress Bar Label - Client view"
          >
            Paid to Freelancer
          </ng-container>
          <ng-container
            *ngSwitchCase="UserPerspective.FREELANCER"
            i18n="
              Quotation Freelancer Funds Progress Bar Label - Freelancer view
            "
          >
            Paid to you
          </ng-container>
        </ng-template>
      </fl-text>

      <fl-text [size]="TextSize.XXSMALL" [weight]="FontWeight.BOLD">
        {{ fundAmount | flCurrency: currency.code }}
      </fl-text>
    </fl-bit>

    <fl-progress-bar
      label="Gradient fill"
      i18n-label="Quotation funds Progress"
      [fill]="ProgressFill.GRADIENT"
      [flMarginBottom]="Margin.XXSMALL"
      [progressPercentage]="progress"
    ></fl-progress-bar>
  `,
  styleUrls: ['./quotation-payment-status-progress.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuotationPaymentStatusProgressComponent implements OnChanges {
  FontWeight = FontWeight;
  FundType = FundType;
  Margin = Margin;
  ProgressFill = ProgressFill;
  TextSize = TextSize;
  UserPerspective = UserPerspective;

  @Input() currency: Currency;
  @Input() fundAmount = 0;
  @Input() quotePrice: number;
  // Toggle Released/Available funds label
  @Input() fundType: FundType;
  // Toggle Client/Fln view
  @Input() userPerspective: UserPerspective;

  progress: number;

  ngOnChanges(changes: SimpleChanges) {
    if (
      this.quotePrice &&
      this.fundAmount &&
      ('fundAmount' in changes || 'quoteAmount' in changes)
    ) {
      this.progress = 100 * (this.fundAmount / this.quotePrice);
    }
  }
}
